export const SET_VEHICLE_TYPES = 'SET_VEHICLE_TYPES';
export const GET_VEHICLE_TYPES = 'GET_VEHICLE_TYPES';

